var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41413 8.66666H4.08079C3.8919 8.66666 3.73368 8.60266 3.60613 8.47466C3.47857 8.34666 3.41457 8.18844 3.41413 8C3.41368 7.81155 3.47768 7.65333 3.60613 7.52533C3.73457 7.39733 3.89279 7.33333 4.08079 7.33333H7.41413V4C7.41413 3.81111 7.47813 3.65289 7.60613 3.52533C7.73413 3.39778 7.89235 3.33377 8.08079 3.33333C8.26924 3.33289 8.42768 3.39689 8.55613 3.52533C8.68457 3.65378 8.74835 3.812 8.74746 4V7.33333H12.0808C12.2697 7.33333 12.4281 7.39733 12.5561 7.52533C12.6841 7.65333 12.7479 7.81155 12.7475 8C12.747 8.18844 12.683 8.34689 12.5555 8.47533C12.4279 8.60378 12.2697 8.66755 12.0808 8.66666H8.74746V12C8.74746 12.1889 8.68346 12.3473 8.55546 12.4753C8.42746 12.6033 8.26924 12.6671 8.08079 12.6667C7.89235 12.6662 7.73413 12.6022 7.60613 12.4747C7.47813 12.3471 7.41413 12.1889 7.41413 12V8.66666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/profile-add.6eb1c231e5a06746aadb12e57d4305af.svg";
export { ForwardRef as ReactComponent };